import type { ChallengeCondition } from "../api/getChallenge";

//ensures that we're always checking for failure conditions before we evaluate win conditions
export const sortConditions = (conditions: ChallengeCondition[]): ChallengeCondition[] => {
    if (conditions.length > 1) {
        //ensure that we're always evaluating failure conditions first
        conditions.sort((a, b) => {
            if (a.threshold === "TARGET" && b.threshold !== "TARGET") {
                return -1;
            }
            if (a.threshold !== "TARGET" && b.threshold === "TARGET") {
                return 1;
            }
            return 0;
        });
    }
    return conditions;
};
